export default __webpack_public_path__ + "static/media/comp1.7950a959.png";